import React from 'react';

import type { ITextProps } from './Text.types';

export const Text: React.FC<ITextProps> = ({
  children,
  variant = 'text-md',
  weight = 'regular',
  color = 'primary',
  align = 'left',
  as: Component = 'p',
  className = '',
  onMouseEnter,
  onMouseLeave,
}: ITextProps) => {

  // Font size and line height mapping
  const variantMapper = {
    'display-2xl': 'text-bg-v2-display-2xl leading-bg-v2-display-2xl',
    'display-xl': 'text-bg-v2-display-xl leading-bg-v2-display-xl',
    'display-lg': 'text-bg-v2-display-lg leading-bg-v2-display-lg',
    'display-md': 'text-bg-v2-display-md leading-bg-v2-display-md',
    'display-sm': 'text-bg-v2-display-sm leading-bg-v2-display-sm',
    'display-xs': 'text-bg-v2-display-xs leading-bg-v2-display-xs',
    'text-xl': 'text-bg-v2-xl leading-bg-v2-text-xl',
    'text-lg': 'text-bg-v2-lg leading-bg-v2-text-lg',
    'text-md': 'text-bg-v2-md leading-bg-v2-text-md',
    'text-sm': 'text-bg-v2-sm leading-bg-v2-text-sm',
    'text-xs': 'text-bg-v2-xs leading-bg-v2-text-xs',
  };

  // Font weight mapping
  const weightMapper = {
    'regular': 'font-bg-v2-regular',
    'medium': 'font-bg-v2-medium',
    'semibold': 'font-bg-v2-semibold',
    'bold': 'font-bg-v2-bold',
  };

  // Text color mapping
  const colorMapper = {
    'primary': 'text-text-primary',
    'secondary': 'text-text-secondary',
    'tertiary': 'text-text-tertiary',
    'quaternary': 'text-text-quaternary',
    'brand-primary': 'text-text-brand-primary',
    'brand-secondary': 'text-text-brand-secondary',
    'brand-tertiary': 'text-text-brand-tertiary',
    'white': 'text-text-white',
    'disabled': 'text-text-disabled',
    'error': 'text-text-error-primary',
    'success': 'text-text-success-primary',
    'warning': 'text-text-warning-primary',
    'placeholder': 'text-text-placeholder',
  };

  // Text alignment mapping
  const alignMapper = {
    'left': 'text-left',
    'center': 'text-center',
    'right': 'text-right',
    'justify': 'text-justify',
  };

  return (
    <Component
      className={`${variantMapper[variant]} ${weightMapper[weight]} ${colorMapper[color]} ${alignMapper[align]} ${className}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </Component>
  );
};

